import React from "react";
import { Star } from "lucide-react";

export function StarRating({ rating, count, size = "sm" }) {
  if (!rating) return null;

  const sizeClass = size === "lg" ? "h-5 w-5" : "h-3.5 w-3.5";
  const textSize = size === "lg" ? "text-sm" : "text-xs";

  return (
    <div className="flex items-center gap-1">
      <div className="flex items-center">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            className={`${sizeClass} ${
              star <= Math.round(rating)
                ? "text-amber-400 fill-amber-400"
                : "text-brand-200"
            }`}
          />
        ))}
      </div>
      <span className={`${textSize} font-semibold text-brand-700`}>{rating}</span>
      {count !== undefined && (
        <span className={`${textSize} text-brand-400`}>({count})</span>
      )}
    </div>
  );
}
